import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentChargeRequest } from '../../models/payment-charge-request.model';
import { environment } from '../../../../../environments/environment';
import { AppMetaDataLookups, CheckRideRequestPaymentPartyAllItems, PaymentCustomerReferenceEntity } from '../../../../meta-data/app-meta-data.service';
import { PaymentRepositoryService } from '../../services/payment-repository.service';
import { PaymentDiscountResult } from '../../models/payment-discount-result.model';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {
  showAddTestCardInfo: boolean = false;
  @Input() chargeRequest: PaymentChargeRequest;
  @Output() chargeRequestChange = new EventEmitter<PaymentChargeRequest>();

  @Input() additionalMessage: string;
  @Input() showPaymentParty: boolean = false;

  payWithApplicantCard = false;

  showCardSelection = false;

  //years: string[] = [];

  paymentPartyLookupId = AppMetaDataLookups.CheckRideRequestPaymentPartyAllItems;

  @Input() paymentDiscountResult: PaymentDiscountResult;
  @Output() paymentDiscountResultChange = new EventEmitter<PaymentDiscountResult>();
  customer: PaymentCustomerReferenceEntity;

  constructor(private paymentRespotioryService: PaymentRepositoryService,) { }

  loading = true;

  ngOnInit(): void {
    //this.setupYears();

    this.showAddTestCardInfo = environment.production === false;

    // Don't show existing cards for Students, since they will only book 1 or at most a few checkrides
    this.showCardSelection = this.chargeRequest.cardOwnerPaymentPartyId != CheckRideRequestPaymentPartyAllItems.Applicant;

    this.setupExistingCards();
    }

  private setupExistingCards() {
    if (!this.showCardSelection) {
      this.loading = false;
      return;
    }


     // Setup saved cards along with the default card if available
    this.paymentRespotioryService.getCustomer(this.chargeRequest.cardOwnerPaymentPartyId)
      .subscribe((customer) => {
        this.customer = customer || { PaymentCard: [] } as any;

        this.setDefaultCard();

        this.loading = false;
      })
  }

  private setDefaultCard() {
    const defaultCard = this.customer?.PaymentCard?.find(card => card.IsDefaultCard);
    if (defaultCard) {
      this.chargeRequest.cardDetails.cardReferenceKey = defaultCard.CardReferenceKey;
    }
  }

  changePartyType() {
    this.chargeRequest.paymentPartyId = this.payWithApplicantCard ? CheckRideRequestPaymentPartyAllItems.Applicant : this.chargeRequest.cardOwnerPaymentPartyId;

    if (this.payWithApplicantCard) {
      this.chargeRequest.paymentPartyId = CheckRideRequestPaymentPartyAllItems.Applicant;
      // reset the selected card to null so they can edit the applicant's card
      this.chargeRequest.cardDetails.cardReferenceKey = null;
    } else {
      // Switch back to the card owner (will be flight school or examiner)
      this.chargeRequest.paymentPartyId = this.chargeRequest.cardOwnerPaymentPartyId;
      this.setDefaultCard();
    }
  }

  applyDiscountCode() {
    this.paymentRespotioryService.applyDiscountCode(this.chargeRequest.paymentDiscountCode, this.chargeRequest.amount)
      .subscribe(result => {
        this.paymentDiscountResult = result;

        this.paymentDiscountResultChange.emit(result);
      });
  }

  onChange() {
    this.chargeRequestChange.emit(this.chargeRequest);
  }

  // private setupYears(): void {
  //   const currentYear = new Date().getFullYear();
  //   const years = [];
  //   for (let i = 0; i < 10; i++) {
  //     years.push((currentYear + i).toString());
  //   }
  //   this.years = years;
  // }

  // addTestCardInfo() {
  //   this.chargeRequest.cardDetails = {
  //     cardholderName: this.chargeRequest.cardDetails.cardholderName,
  //     cardNumber: '4242424242424242',
  //     expirationMonth: '12',
  //     expirationYear: '2025',
  //     cVC: '123',
  //     cardholderPostalCode: '12345',
  //   }
  // }
}
